import { Component, OnInit } from '@angular/core';
import { SocketclientService } from '../socketclient.service';
import { JsonpClientBackend } from '@angular/common/http';
import { Customer } from '../Models/customer.model';
import { CookieService } from 'ngx-cookie-service';
import { global } from '../../shared/global';
import { MouseEvent } from '@agm/core';
import { Router } from '@angular/router';
declare var $: any;

@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.css']
})
export class CustomerComponent implements OnInit {

  // Start --> Variables for value of controls
  id: any;
  contacts: any;
  address: number;
  asccode: string;
  break_end_time: string;
  break_start_time: string;
  currenttokens: string;
  email: string;
  end_time: string;
  is_break_available: number;
  name: string;
  phone1: string;
  phone2: string;
  start_time: string;
  // End

  // Start --> Variables for token controls
  tokenname: string;
  origseries: string;
  time: string;
  storeAddress: string;
  // End

  termConditionLink: any;

  data: Customer;
  services: any;
  stores: any;
  cookieValue: any;
  locationCookie: any;
  tokens: any;
  pincodeCookie: any;

  pincode: any;
  mobile: any;
  imageUrl: any;

  lat: any;
  lng: any;
  zoom: number = 15;

  constructor(private sw: SocketclientService, private cookieService: CookieService, private router: Router) {
    this.pincodeCookie = this.cookieService.get("pincodes");
    if (this.pincodeCookie) {
      this.pincodeCookie = JSON.parse(this.pincodeCookie);
      for (var pin in this.pincodeCookie) {
        if (this.pincodeCookie[pin].selected == 1) {
          this.pincode = this.pincodeCookie[pin].pincode;
        }
      }
    }

    this.cookieValue = this.cookieService.get("login");
    this.locationCookie = this.cookieService.get("locations");
    let tempthis = this;

    if (navigator) {
      navigator.permissions.query({ name: 'geolocation' }).then(function (result) {
        if (result.state == 'granted') {
          navigator.geolocation.getCurrentPosition(pos => {
            // if (tempthis.locationCookie) {
            //   tempthis.locationCookie = JSON.parse(tempthis.cookieService.get("locations"));
            //   tempthis.lng = +tempthis.locationCookie.longitude;
            //   tempthis.lat = +tempthis.locationCookie.latitude;
            // }
            // else {
              // console.log(pos);
            tempthis.lng = +pos.coords.longitude;
            tempthis.lat = +pos.coords.latitude;
            // }

            if (tempthis.cookieValue) {
              // 20.4537856, 72.8399872
              // var str2 = { "filterid": "0", "pincode": tempthis.pincode, "latitude": "21.2046078", "usertype": "doctorlist", "longitude": "72.8399872" };
              var str2 = { "filterid": "0", "pincode": tempthis.pincode, "latitude": tempthis.lat, "usertype": "doctorlist", "longitude": tempthis.lng };
              tempthis.sw.send(JSON.stringify(str2));
              // console.log(str2);

              // 21.1602352,72.8091103
            }
          });
          console.log(result.state);
        } else if (result.state == 'prompt') {
          console.log(result.state);
          navigator.geolocation.getCurrentPosition(pos => {
            // if (tempthis.locationCookie) {
            //   tempthis.locationCookie = JSON.parse(tempthis.cookieService.get("locations"));
            //   tempthis.lng = +tempthis.locationCookie.longitude;
            //   tempthis.lat = +tempthis.locationCookie.latitude;
            // }
            // else {
            tempthis.lng = +pos.coords.longitude;
            tempthis.lat = +pos.coords.latitude;
            // }

            if (tempthis.cookieValue) {
              // var str2 = { "filterid": "0", "pincode": tempthis.cookieValue.pincode, "latitude": tempthis.lat, "usertype": "doctorlist", "longitude": tempthis.lng };
              var str2 = { "filterid": "0", "pincode": tempthis.pincode, "latitude": tempthis.lat, "usertype": "doctorlist", "longitude": tempthis.lng };
              tempthis.sw.send(JSON.stringify(str2));
            }
          });
        } else if (result.state == 'denied') {
          console.log(result.state);
        }
        result.onchange = function () {
          console.log(result.state);
        }
      });
    }

    this.sw.WebSocketMessage().subscribe(data => {
      this.onReceive(data);
    });

    this.sw.WebSocketConnected().subscribe(() => {
      this.onOpen();
    });

    if (this.cookieValue) {
      this.cookieValue = JSON.parse(this.cookieService.get("login"));

      // var str = { "pincode": this.cookieValue.pincode, "latitude": "0.0", "usertype": "servicefilter", "longitude": "0.0" };
      var str = { "pincode": this.pincode, "latitude": "0.0", "usertype": "servicefilter", "longitude": "0.0" };
      this.sw.send(JSON.stringify(str));

      // var str1 = { "filterid": "0", "pincode": this.cookieValue.pincode, "latitude": "0.0", "usertype": "doctorlist", "longitude": "0.0" };
      var str1 = { "filterid": "0", "pincode": this.pincode, "latitude": "0.0", "usertype": "doctorlist", "longitude": "0.0" };
      this.sw.send(JSON.stringify(str1));
    } else {
    }
  }

  ngOnInit() {
    this.data = new Customer();
    this.termConditionLink = global.termConditionLink;
    this.imageUrl = global.imageUrl;

    document.getElementById("divMsg").style.display = "none";
    document.getElementById("divServices").style.display = "block";

    if (this.cookieValue) {
      this.mobile = this.cookieValue.mobile;
      // this.pincode = this.cookieValue.pincode;
      this.pincode = this.pincode;
    } else {
      this.router.navigate(["/login"]);
    }
  }

  onReceive(Data) {
    if (Data) {
      const msg = JSON.parse(Data);
      if (msg.usertype == "servicefilter") {
        if (msg.isSuccess) {
          this.services = msg.data;
          this.data.serviceid = 0;

          // if (this.cookieValue) {
          //   var str3 = { "filterid": "0", "pincode": this.cookieValue.pincode, "latitude": this.lat, "usertype": "doctorlist", "longitude": this.lng };
          //   this.sw.send(JSON.stringify(str3));
          //   console.log(str3);
          // }
        }
      }

      if (msg.usertype == "doctorlist") {
        if (msg.isSuccess) {
          this.fillStores(msg.data);

          document.getElementById("divMsg").style.display = "none";
          document.getElementById("divServices").style.display = "block";
        } else {
          this.stores = null;
          document.getElementById("divMsg").style.display = "block";
          document.getElementById("divServices").style.display = "none";
        }
      }

      if (msg.usertype == "doctordetails") {
        if (msg.isSuccess) {
          this.contacts = msg.data;

          // Start -->Set Values For Contact Us Detail
          this.name = this.contacts.name;
          this.address = this.contacts.address;
          this.phone1 = this.contacts.phone1;
          this.phone2 = this.contacts.phone2;
          this.email = this.contacts.email;
          this.start_time = this.contacts.start_time;
          this.end_time = this.contacts.end_time;
          this.break_start_time = (this.contacts.is_break_available == 1 ? this.contacts.break_start_time : "-");
          this.break_end_time = (this.contacts.is_break_available == 1 ? this.contacts.break_end_time : "-");
          // End
        }
      }

      if (msg.usertype == "token") {
        if (msg.isSuccess) {
          this.tokens = msg.data;

          this.origseries = this.tokens.origseries;
          this.tokenname = this.tokens.name;
          this.time = this.tokens.time;

          $('#tokenModal').modal('show');
        }
      }
    }
    else {
      this.services = null;
      this.stores = null;
    }
  }

  onOpen() {
    console.log("Wesocket Connected");
  }

  fillStores(recData) {
    this.stores = recData;
  }

  callStore(filterId) {
    // var str1 = { "filterid": filterId, "pincode": this.cookieValue.pincode, "latitude": this.lat, "usertype": "doctorlist", "longitude": this.lng };
    var str1 = { "filterid": filterId, "pincode": this.pincode, "latitude": this.lat, "usertype": "doctorlist", "longitude": this.lng };
    this.sw.send(JSON.stringify(str1));

    var locations = {
      "longitude": this.lng,
      "latitude": this.lat,
    }

    this.cookieService.set("locations", JSON.stringify(locations));
  }

  logout() {
    this.cookieService.delete("login");
    this.cookieService.delete("locations");
    this.cookieService.delete("shop");
    this.cookieService.delete("staff");
    this.cookieService.delete("config");
    this.cookieService.delete("pincodes");
    this.router.navigate(["/login"]);
  }

  callCustomerToken(sId, asccode) {
    this.router.navigate(["/customertoken/" + sId + "/" + asccode]);
  }

  setContactInfo(storeId) {
    this.id = storeId;
    var str = { "doctorid": storeId, "usertype": "doctordetails" };
    this.sw.send(JSON.stringify(str));
  }

  getToken(asccode, storeName, storeStatus, storeArea, event) {
    event.srcElement.setAttribute('disabled', true);

    this.name = storeName
    this.storeAddress = storeArea;
    if (storeStatus == 1) {
      var str2 = { "asccode": asccode, "usertype": "token", "mobileno": this.cookieValue.mobile, "type": "A", "lang": "en", "priority": "9009" }
      this.sw.send(JSON.stringify(str2));
    } else {
      $('#storeCloseModal').modal('show');
    }

    setTimeout(() => {
      event.srcElement.removeAttribute('disabled');
    }, 3000);

  }

  markerDragEnd($event: MouseEvent) {
    this.lat = $event.coords.lat;
    this.lng = $event.coords.lng;
  }

  closeModal() {
    setTimeout(() => {
      $('#tokenModal').modal('hide');
    }, 3000);

    setTimeout(() => {
      $('#storeCloseModal').modal('hide');
    }, 2000);
  }

  setVendorConfig() {
    var objConfig = {
      "isStaff": 0
    }

    this.cookieService.set("config", JSON.stringify(objConfig));
  }
}